import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import IndividualClientDetails from "../components/IndividualClientDetails";

const IndividualClientDetailsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Client Details' />

        {/* BlankPageLayer */}
        <IndividualClientDetails />
      </MasterLayout>
    </>
  );
};

export default IndividualClientDetailsPage;

